import React, { FunctionComponent } from 'react';
import { useMediaQuery } from 'react-responsive';

import FloatingActionButton from '@Components/Buttons/FloatingActionButton';
import { MediaQueries, SCROLL_THRESHOLD_PX } from '@Config/constants';
import { useScrolled } from '@Hooks/useScrolled';

import styles from './MarketPlaceFloatingNavigationContent.module.scss';

export interface MarketPlaceFloatingNavigationContentProps {
  onFilterClick: () => void;
}

const MarketPlaceFloatingNavigationContent: FunctionComponent<MarketPlaceFloatingNavigationContentProps> = ({
  onFilterClick,
}) => {
  const scrolled = useScrolled();
  const isScrolledToThreshold = scrolled > SCROLL_THRESHOLD_PX;
  const isMobile = useMediaQuery({ maxWidth: MediaQueries.mobile });
  if (!isMobile && !isScrolledToThreshold) {
    return null;
  }

  return (
    <>
      {isScrolledToThreshold && (
        <FloatingActionButton className={styles.icon} icon="scroll-top" onClick={() => window.scrollTo(0, 0)} />
      )}
      {isMobile && <FloatingActionButton className={styles.icon} icon="filter" onClick={onFilterClick} />}
    </>
  );
};

export default MarketPlaceFloatingNavigationContent;
